module.exports = __webpack_public_path__ + "img/deco-bottom.1b47646.jpg";